// extracted by mini-css-extract-plugin
export var chevron = "_1m-d";
export var disabled = "_1m-b";
export var error = "_1m-c";
export var hideBorder = "_1m-1";
export var icon = "_1m-e";
export var input = "_1m-0";
export var large = "_1m-f";
export var open = "_1m-9";
export var placeholder = "_1m-a";
export var regular = "_1m-5";
export var singleRowInput = "_1m-2";
export var singleSelectInput = "_1m-3 _1m-0";
export var small = "_1m-4";
export var spinnerContainer = "_1m-i";
export var tag = "_1m-7";
export var tagsContainer = "_1m-8";
export var tagsInput = "_1m-6 _1m-0";
export var xSmall = "_1m-g";
export var xxSmall = "_1m-h";